import React from "react";

type CloseProps = {
  className?: string;
}

export const Close = ({ className }: CloseProps) => {
  return (
    <svg className={className} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.41406" y="0.978516" width="20" height="2" transform="rotate(45 1.41406 0.978516)" fill="#0B0C0C"/>
      <rect x="15.5566" y="2.13672" width="20" height="2" transform="rotate(135 15.5566 2.13672)" fill="#0B0C0C"/>
    </svg>
  )
}
